import { createSelector } from 'reselect';
import { getSearch } from '../../search-and-filter-schema/protected';
import { DEFAULT_CHAT_FILTERS } from './defaultChatFilters';
import { selectFilterValues } from './selectFilterValues';
export const selectHasSearchSet = createSelector([selectFilterValues], filterValues => {
  return getSearch(filterValues) !== getSearch(DEFAULT_CHAT_FILTERS);
});